import type { HrefOrHrefWithParams } from 'next-intl/dist/types/navigation/shared/utils';

import type { AdvertisementRenderLink } from '@cineamo/composables/src/advertisement/link';

import { Link } from '@/i18n/routing';

// cinema-website needs a locale-aware, typed `Link` (so `/program/[contentId]` translates to
// `/programm/[contentId]` in German) — the composable's `DefaultAdvertisementLink` can't know
// about next-intl's typed `pathnames`, so this host supplies its own `renderLink`.
export const advertisementRenderLink: AdvertisementRenderLink = ({ target, onClick, className, children }) => {
    if (target.kind === 'none') {
        return <>{children}</>;
    }

    const href: string | HrefOrHrefWithParams<string> =
        target.kind === 'url'
            ? target.href
            : ({
                  pathname: '/program/[contentId]',
                  params: {
                      contentId: target.contentId
                  }
              } as HrefOrHrefWithParams<string>);

    return (
        <Link
            href={href}
            onClick={onClick}
            className={className}>
            {children}
        </Link>
    );
};
